import { render, staticRenderFns } from "./ParrainageList.vue?vue&type=template&id=08156758&scoped=true"
import script from "./ParrainageList.vue?vue&type=script&lang=ts"
export * from "./ParrainageList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08156758",
  null
  
)

export default component.exports